// extracted by mini-css-extract-plugin
export default {"image":"mZ-z","loaded":"nZ-z"};